import { Button } from "@grupoboticario/flora-react";
import { Logo } from "../../components/Logo";
import {
  FooterCenter,
  FooterContainer,
  FooterLeft,
  FooterRight,
} from "./style";

export default function Footer() {
  return (
    <FooterContainer>
      <FooterCenter>
        <a
          href="https://privacidade.grupoboticario.com.br/"
          target="_blank"
          rel="Politica de Privacidade"
        >
          <Button size="small">
            Politica de Privacidade
          </Button>
        </a>
        <a
          href="https://conectab2b.multib.com/documents/termos_de_uso.pdf"
          target="_blank"
          rel="Termo de uso"
        >
          <Button size="small">
            Termo de uso
          </Button>
        </a>
      </FooterCenter>
    </FooterContainer>
  );
}
